import type { AccordionDesignTokens } from '@primeuix/themes/types/accordion'
import type { CardDesignTokens } from '@primeuix/themes/types/card'
import type { PanelDesignTokens } from '@primeuix/themes/types/panel'

import { bothSchemes } from '../utils'

/** Белая карточка-секция: r=20, padding 16, без тени. */
export const cardConfig = (): CardDesignTokens => ({
  root: {
    borderRadius: 'var(--radius-xl)',
    shadow: 'none',
  },
  body: {
    padding: 'var(--screen-padding)',
    gap: 'var(--space-5)',
  },
  caption: {
    gap: 'var(--space-2)',
  },
  title: {
    fontWeight: 'var(--fw-bold)',
  },
  colorScheme: bothSchemes({
    root: {
      background: 'var(--surface-card)',
      color: 'var(--text-color)',
    },
    subtitle: { color: 'var(--text-color-secondary)' },
  }),
})

export const panelConfig = (): PanelDesignTokens => ({
  root: {
    borderRadius: 'var(--radius-xl)',
  },
  header: { padding: 'var(--screen-padding)' },
  title: { fontWeight: 'var(--fw-bold)' },
  content: { padding: '0 var(--screen-padding) var(--screen-padding)' },
  footer: { padding: '0 var(--screen-padding) var(--screen-padding)' },
  colorScheme: bothSchemes({
    root: {
      background: 'var(--surface-card)',
      borderColor: 'transparent',
      color: 'var(--text-color)',
    },
  }),
})

/** «Состав», «Сделать вкуснее», FAQ в профиле. */
export const accordionConfig = (): AccordionDesignTokens => ({
  root: {
    transitionDuration: '.2s',
  },
  panel: {
    borderWidth: '0',
  },
  header: {
    padding: 'var(--space-7) 0',
    fontWeight: 'var(--fw-bold)',
    borderRadius: 'var(--radius-m)',
    borderWidth: '0',
    focusRing: { width: '0', style: 'none', offset: '0' },
  },
  content: {
    padding: '0 0 var(--space-7)',
    borderWidth: '0',
  },
  colorScheme: bothSchemes({
    panel: { borderColor: 'transparent' },
    header: {
      color: 'var(--text-color)',
      hoverColor: 'var(--text-color)',
      activeColor: 'var(--text-color)',
      activeHoverColor: 'var(--text-color)',
      background: 'transparent',
      hoverBackground: 'transparent',
      activeBackground: 'transparent',
      activeHoverBackground: 'transparent',
      borderColor: 'transparent',
    },
    content: {
      background: 'transparent',
      borderColor: 'transparent',
      color: 'var(--text-color-secondary)',
    },
  }),
})
